import { Button, Tooltip } from 'antd';
import React from 'react';
import { EditOutlined} from '@ant-design/icons';

export const InfoDeviceColumn = (handleEdit: (record: any) => void) => [
  
  {
    title: 'Info Device Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'Device Type Id',
    dataIndex: 'deviceTypeId',
    key: 'deviceTypeId',
    hidden: true,
  },
  {
    title: 'Denumire',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Tip device',
    dataIndex: ['deviceType', 'name'],
    key: 'deviceTypeName',
  
  },
  {
    title: 'Model',
    dataIndex: 'model',
    key: 'model',
    width: 200,
  },
  {
    title: 'Numar piese',
    dataIndex: 'pieces',
    key: 'pieces',
    width: 200,
  },
  {
    title: 'Actiune',
    dataIndex: '',
    key: 'actions',
    render: (record: any) =>
      <Tooltip title='Modifica'>
       <Button onClick={() => handleEdit(record)} icon={<EditOutlined/>}></Button>
       </Tooltip>,
    width: 120,
    fixed: 'right'
  },
];
